import { MessageCenter } from './messageCenter';

const messageCenter = new MessageCenter();

export function useMessageCenter() {
    return messageCenter;
}
